// src/data/services.js  (example – update with your real images)
import service1 from '../Assets/Services/PD.webp'
import service2 from '../Assets/Services/GC.webp'
import service3 from '../Assets/Services/Endodontic.jpeg'
import service4 from '../Assets/Services/LD.webp'
import service5 from '../Assets/Services/C&B.webp'
import service6 from '../Assets/Services/Dentures.webp'
import service7 from '../Assets/Services/O&M.webp'
import service8 from '../Assets/Services/Orthodontics.webp'
import service9 from '../Assets/Services/Cosmetic Dentistry.webp'
import service10 from '../Assets/Services/dentalimplants.webp'



export default [
  {
    title: "Pediatric Dentistry",
    description: "Gentle dental care to keep children’s teeth healthy from the start.",
    image: service1,
    icon: "🦷",
        link: "/treatments/pediatric-dentistry"  

  },
  {
    title: "Gum Care",
    description: "Treatment and prevention of gum infections and gum disease.",
    image: service2,
    icon: "🦷",
    link: "/treatments/gum-care"
  },
  {
    title: "Endodontic",
    description: "Root canal treatment to save infected or damaged teeth.",
    image: service3,
    icon: "🦷",
     link: "/treatments/endodontic"
  },
  {
    title: "Laser Dentistry",
    description: "Advanced painless dental treatments using laser technology.",
    image: service4,
    icon: "🦷",
    link: "/treatments/laser-dentistry"
  },
  {
    title: "Crowns & Bridges",
    description: "Restores damaged or missing teeth for strength and appearance.",
    image: service5,
    icon: "🦷",
    link: "/treatments/crowns-and-bridges"
  },
  {
    title: "Dentures",
    description: "Custom artificial teeth to replace missing natural teeth.",
    image: service6,
    icon: "🦷",
     link: "/treatments/dentures"
  },
  {
    title: "Oral & Maxillofacial Surgery",
    description: "Surgical treatment for complex dental and jaw conditions.",
    image: service7,
    icon: "🦷",
    link: "/treatments/oral-maxillofacial-surgery"
  },
  {
    title: "Orthodontics",
    description: "Aligns crooked teeth and corrects bite problems, well-balanced smile.",
    image: service8,
    icon: "🦷",
    link: "/treatments/orthodontics"
  },
  {
    title: "Cosmetic Dentistry",
    description: "Enhances your smile with whitening and aesthetic treatments.",
    image: service9,
    icon: "🦷",
    link: "/treatments/cosmetic-dentistry"
  },
  {
    title: "Dental Implants",
    description: "Dental Implant is a surgical process to implant an artificial tooth root. ",
    image: service10,
    icon: "🦷",
    link: "/treatments/dental-implants"
  },
];
